import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-download-popup',
  templateUrl: './download-popup.component.html',
  styleUrls: ['./download-popup.component.scss'],
})
export class DownloadPopupComponent implements OnInit {
  @ViewChild('downloadPopup') downloadPopup: ElementRef<HTMLElement>;

  constructor() {}

  ngOnInit(): void {}

  hidePopUp() {
    this.downloadPopup.nativeElement.classList.add('hide');
  }

  public get isMobileIos() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  public get isMobileAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  public get isNative() {
    return Capacitor.isNativePlatform();
  }
}
